import React from 'react';

interface LoadingStateProps {
  /** Number of skeleton cards to show */
  cards?: number;
  /** Layout: 'grid' for StatsCard-style, 'list' for DataCard-style */
  layout?: 'grid' | 'list';
}

function SkeletonCard({ height = 'h-24' }: { height?: string }) {
  return (
    <div className={`bg-white rounded-lg border border-gray-100 ${height} overflow-hidden`}>
      <div className="h-full animate-shimmer rounded-lg" />
    </div>
  );
}

export default function LoadingState({ cards = 4, layout = 'grid' }: LoadingStateProps) {
  if (layout === 'list') {
    return (
      <div className="space-y-3 animate-fade-in">
        {Array.from({ length: cards }).map((_, i) => (
          <SkeletonCard key={i} height="h-20" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 animate-fade-in">
      {Array.from({ length: cards }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
